'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutomationName = function () {
  function AutomationName() {
    (0, _classCallCheck3.default)(this, AutomationName);
  }

  (0, _createClass3.default)(AutomationName, null, [{
    key: 'get',

    /**
     * Creates standard automation name composed of type and unique name
     * 
     * @static
     * @param {string} type 
     * @param {string} name 
     * @returns {string}
     * @memberof AutomationName
     */
    value: function get(type, name) {
      if (!type || !name) {
        return undefined;
      }

      return AutomationName.format(type) + '_' + AutomationName.format(name);
    }

    /**
     * Trims white space
     * Replaces spaces with underscores
     * Converts all characters to lowercase
     * 
     * @static
     * @param {string} str 
     * @returns {string}
     * @memberof AutomationName
     */

  }, {
    key: 'format',
    value: function format(str) {
      if (str) {
        return str.trim().replace(/\s+/g, '_').toLowerCase();
      } else {
        return null;
      }
    }
  }]);
  return AutomationName;
}();

exports.default = AutomationName;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/AutomationName.js
// module id = 13
// module chunks = 10